

import React, { Component } from 'react';
import cx from 'classnames';
import { withSize } from 'react-sizeme';
import { Button, Dropdown } from '../../../ui-kit';
import getCurrentlySelectedBlock from '../utils/getCurrentlySelectedBlock';
import { ALIGNMENT_DATA_KEY } from './ExtendedRichUtils';
import StyleButton from './StyleButton';
import '../styles/_editor-controls.scss';

const MEDIUM_BREAKPOINT = 890;
const SMALL_BREAKPOINT = 415;

const HEADING_TYPES = [
{ label: <span className="editor-controls__headings__item"><h1>Heading 1</h1></span>, value: 'header-one' },
{ label: <span className="editor-controls__headings__item"><h2>Heading 2</h2></span>, value: 'header-two' },
{ label: <span className="editor-controls__headings__item"><h3>Heading 3</h3></span>, value: 'header-three' },
{ label: <span className="editor-controls__headings__item"><h4>Heading 4</h4></span>, value: 'header-four' },
{ label: <span className="editor-controls__headings__item"><h5>Body</h5></span>, value: 'body' }];


const INLINE_CONTROLS = [
{ icon: 'bold', value: 'BOLD' },
{ icon: 'italic', value: 'ITALIC' },
{ icon: 'underline', value: 'UNDERLINE' }];


const ALIGN_CONTROLS = [
{ icon: 'alignleft', value: 'left' },
{ icon: 'aligncenter', value: 'center' },
{ icon: 'alignright', value: 'right' },
{ icon: 'alignjustified', value: 'justify' }];


const BLOCK_TYPES = [
{ icon: 'blockquote', value: 'blockquote' },
{ icon: 'bulletlist', value: 'unordered-list-item' },
{ icon: 'bulletnumeric', value: 'ordered-list-item' }];














class StyleControls extends Component {




  constructor(props) {
    super(props);

    this.toolsButtonRef = React.createRef();
    this.toolsDropdownRef = React.createRef();
    this.state = {
      isToolsDropdownOpen: false
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    const { isToolsDropdownOpen } = this.state;
    const isClickOutside = this.toolsDropdownRef && this.toolsDropdownRef.current &&
    this.toolsButtonRef && this.toolsButtonRef.current &&
    !this.toolsDropdownRef.current.contains(event.target) &&
    !this.toolsButtonRef.current.contains(event.target);

    if (isClickOutside && isToolsDropdownOpen) {
      this.setState({
        isToolsDropdownOpen: false
      });
    }
  };

  handleHeaderChange = ({ value }) => {
    const { onToggle } = this.props;

    onToggle(value)();
  };

  toggleToolsDropdown = () => {
    const { isToolsDropdownOpen } = this.state;

    this.setState({
      isToolsDropdownOpen: !isToolsDropdownOpen
    });
  };

  render() {
    const { editorState, onToggleAlignment, onToggle, onToggleInline, size } = this.props;
    const { isToolsDropdownOpen } = this.state;

    const selection = editorState.getSelection();
    const blockType = editorState.
    getCurrentContent().
    getBlockForKey(selection.getStartKey()).
    getType();

    const { currentBlock } = getCurrentlySelectedBlock(editorState);
    const alignment = currentBlock.getData().get(ALIGNMENT_DATA_KEY);
    const currentStyle = editorState.getCurrentInlineStyle();

    const { width: containerWidth } = size;
    const isExtraSmall = containerWidth <= SMALL_BREAKPOINT;

    const inlineControls = INLINE_CONTROLS.map(({ icon, value }) =>
    <StyleButton
      key={value}
      onToggle={onToggleInline(value)}
      icon={icon}
      selected={currentStyle.has(value)} />

    );
    const alignControls = ALIGN_CONTROLS.map(({ icon, value }) =>
    <StyleButton
      key={value}
      onToggle={onToggleAlignment(value)}
      icon={icon}
      selected={value === alignment} />

    );
    const blockTypes = BLOCK_TYPES.map(({ icon, value }) =>
    <StyleButton
      key={value}
      onToggle={onToggle(value)}
      icon={icon}
      selected={value === blockType} />

    );

    return (
      <div className={cx('editor-controls', {
        'editor-controls__medium': containerWidth <= MEDIUM_BREAKPOINT && containerWidth > SMALL_BREAKPOINT,
        'editor-controls__small': isExtraSmall
      })}>

        <div className="controls-wrapper">
          <Dropdown
            className="editor-controls__headings"
            options={HEADING_TYPES}
            value={HEADING_TYPES.find(({ value }) => value === blockType) || HEADING_TYPES.find(({ value }) => value === 'body')}
            onChange={this.handleHeaderChange}
            hideSeparators
            height={40}
            type="BUTTON" />

          {!isExtraSmall ?
          <>
              <div className="editor-controls__divider" />
              <div className="editor-controls__block">
                {inlineControls}
              </div>
              <div className="editor-controls__divider" />
              <div className="editor-controls__block">
                {alignControls}
              </div>
              <div className="editor-controls__divider" />
              <div className="editor-controls__block">
                {blockTypes}
              </div>
            </> :

          <div className="editor-controls__small">
              <div ref={this.toolsButtonRef}>
                <Button
                className={cx('editor-controls__tools-button', { 'is-active': isToolsDropdownOpen })}
                type="TERTIARY"
                prefix="options"
                prefixSize={20}
                onClick={this.toggleToolsDropdown} />

              </div>
              {
            isToolsDropdownOpen &&
            <div
              className="editor-controls__tools-dropdown"
              ref={this.toolsDropdownRef}>

                    {inlineControls}
                    {alignControls}
                    {blockTypes}
                  </div>}


            </div>}

        </div>
      </div>);

  }
}

export default withSize()(StyleControls);